import { useState } from 'react';
import { useMutation } from 'urql';
import PageHeader from '@/components/common/PageHeader.jsx';
import Field from '@/components/common/Field.jsx';
import StickyActions from '@/components/common/StickyActions.jsx';
import { PORTAL_LOGIN } from './gql.js';

const FORM_ID = 'portal-login-form';

export default function PortalLoginPage() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [resultMessage, setResultMessage] = useState(null);
  const [, login] = useMutation(PORTAL_LOGIN);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const result = await login({ email: form.email, password: form.password });
    if (result.error) {
      setResultMessage({ type: 'error', text: result.error.message });
    } else {
      setResultMessage({ type: 'success', text: `Token emitido: ${result.data.portalLogin.token}` });
    }
  };

  return (
    <div className="w-full">
      <PageHeader title="Portal de Clientes" subtitle="Acceso seguro para seguimiento de envíos y reclamos" />
      <form id={FORM_ID} onSubmit={handleSubmit} className="mx-auto mt-6 grid w-full max-w-[480px] gap-5">
        <section className="rounded-2xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--panel),0.98)] p-6 shadow-xl">
          <Field label="Email" htmlFor="email" required>
            <input
              id="email"
              type="email"
              value={form.email}
              onChange={event => setForm(prev => ({ ...prev, email: event.target.value }))}
              className="w-full rounded-xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--subpanel),0.6)] px-3 py-2 text-sm text-[rgb(var(--fg))] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
            />
          </Field>
          <Field label="Contraseña" htmlFor="password" required>
            <input
              id="password"
              type="password"
              value={form.password}
              onChange={event => setForm(prev => ({ ...prev, password: event.target.value }))}
              className="w-full rounded-xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--subpanel),0.6)] px-3 py-2 text-sm text-[rgb(var(--fg))] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
            />
          </Field>
          {resultMessage ? (
            <p
              className={`mt-4 text-sm ${resultMessage.type === 'error' ? 'text-rose-500' : 'text-emerald-500'}`}
            >
              {resultMessage.text}
            </p>
          ) : null}
        </section>
      </form>

      <StickyActions>
        <div className="flex w-full items-center justify-end">
          <button
            type="submit"
            form={FORM_ID}
            className="rounded-xl bg-[rgb(var(--brand))] px-4 py-2 text-sm font-semibold text-white shadow focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
          >
            Ingresar
          </button>
        </div>
      </StickyActions>
    </div>
  );
}
